/*
  Base component used in the Modal Service
  src/components/base/ModalService.js
*/

import _ from 'lodash';
import template from './confirmation.modal.html';

export default {
  name: 'confirmationModal',
  controller() {
    this.confirm = result => this.close({ $value: result });
    this.cancel = result => this.dismiss({ $value: result });

    this.userValidatedTyping = () =>
      _.toLower(this.resolve.modalOptions.typeToConfirm) === _.toLower(this.validateTyping);
  },
  template,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};
